module.exports = __webpack_public_path__ + "static/media/Programmer.27e8bde1.jpg";